import useIsMobile from 'utils/hooks/useIsMobile'
import {
  Backdrop,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
} from '@mui/material'
import TextField from '@mui/material/TextField'
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers-pro'
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs'
import dayjs from 'dayjs'
import {useState} from 'react'
/*icons*/
import DownloadIcon from '@mui/icons-material/Download'
import fileDownload from 'js-file-download'
import {useSelector} from 'react-redux'
import {toast, ToastContainer} from 'react-toastify'
import {imageModeConst} from 'utils/const/globalConst'
import {envBackHost} from '../../GLOBAL/envVariables'
import {axiosWithAuth} from '../../helper/axiosWithAuth'
import {resultAlert} from '../../utils/CustomAlert/Alert'
import ExcelFormEditModal from './../common/ExcelFormEditModal'

interface DOWNLOAD_TYPE {
  type: string
  data?: any
  search?: any
  open: boolean
  onClose: () => void
}

const FIELD_COMMUNICATION_QUALITY_REQUEST = 'fieldCommunicationQualityRequest'

const ExcelDownLoadModal = (props: DOWNLOAD_TYPE) => {
  const path = window.location.pathname
  const isMobile = useIsMobile()

  const {type, data, search, open, onClose} = props
  const [imageMode, setImageMode] = useState<any>(imageModeConst.recentImage)
  const [fixedExcelForm, setFixedExcelForm] = useState('')
  const [excelFormEditOpen, setExcelFormEditOpen] = useState(false)
  const [filter, setFilter] = useState({
    date: dayjs().format('YYYYMMDD'),
  })
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  const officeInfo = useSelector((state: any) => state.officeInfo)

  const getDownloadData = async (path: any) => {
    switch (path) {
      case '/customer/binary-check':
        return await toast
          .promise(
            axiosWithAuth()
              .get(
                `${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}/customer/image-verify/excel`,
                {
                  params: search,
                  responseType: 'blob',
                }
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(
                  res.data,
                  `${officeInfo?.label}_${search.startDate}~${search.endDate}_${type}.xlsx`
                )
                onClose()
              })
              .catch(async () => {
                await resultAlert({resultCode: 400})
              }),
            {pending: '다운로드 중입니다.'},
            {position: 'top-center', autoClose: 1000, className: 'fs-3 fw-bold'}
          )
          .catch(async () => {
            await resultAlert({resultCode: 400})
          })

      case '/customer/minimum-flow':
        return await toast
          .promise(
            axiosWithAuth()
              .get(
                `${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}${window.location.pathname}/excel`,
                {
                  params: search,
                  responseType: 'blob',
                }
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(res.data, `${officeInfo?.label}_${search.date}_${type}.xlsx`)
                onClose()
              })
              .catch(async () => {
                await resultAlert({resultCode: 400})
              }),
            {pending: '다운로드 중입니다.'},
            {position: 'top-center', autoClose: 1000, className: 'fs-3 fw-bold'}
          )
          .catch(async () => {
            await resultAlert({resultCode: 400})
          })

      case '/customer/allocation':
        const filteredData = data.map((item: any) => ({
          officeId: item.officeId,
          customerNumber: item.customerNumber,
        }))
        return await toast
          .promise(
            axiosWithAuth()
              .post(
                `${envBackHost}/${officeInfo?.value}/customer/assign/excel`,
                {...search, selectedCustomers: filteredData},
                {responseType: 'blob'}
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(res.data, `${officeInfo?.label}_${type}.xlsx`)
                onClose()
              })
              .catch(async () => {
                await resultAlert({resultCode: 400})
              }),
            {pending: '다운로드 중입니다.'},
            {position: 'top-center', autoClose: 1000, className: 'fs-3 fw-bold'}
          )
          .catch(async () => {
            await resultAlert({resultCode: 400})
          })

      case '/customer/info':
        const isFieldCommunicationQualityRequest =
          fixedExcelForm === FIELD_COMMUNICATION_QUALITY_REQUEST
        const customerInfoExcelUrl = isFieldCommunicationQualityRequest
          ? `${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}/field-communication-quality-request/excel`
          : `${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}${window.location.pathname}/excel?date=${filter.date}&userId=${userInfo?.userId}`

        return await toast
          .promise(
            axiosWithAuth()
              .get(customerInfoExcelUrl, {
                params:
                  excelImageModeHandler(path) && !isFieldCommunicationQualityRequest
                    ? {...search, excelMode: imageMode}
                    : search,
                responseType: 'blob',
              })
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(
                  res.data,
                  isFieldCommunicationQualityRequest
                    ? `${officeInfo?.label}_현장통품점검 요청.xlsx`
                    : `${officeInfo?.label}_${filter.date}_${type}.xlsx`
                )
                onClose()
              })
              .catch(async () => {
                await resultAlert({resultCode: 400})
              }),
            {pending: '다운로드 중입니다.'},
            {position: 'top-center', autoClose: 1000, className: 'fs-3 fw-bold'}
          )
          .catch(async () => {
            await resultAlert({resultCode: 400})
          })

      case '/customer/check-report':
        return await toast
          .promise(
            axiosWithAuth()
              .get(
                `${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}/customer/check-report/excel`,
                {
                  params: {
                    date: filter.date,
                    userId: userInfo?.userId,
                    searchOption: search?.searchOption,
                    searchData: search?.searchData,
                  },
                  responseType: 'blob',
                }
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(res.data, `${officeInfo?.label}_${filter.date}_${type}.xlsx`)
                onClose()
              })
              .catch(async () => {
                await resultAlert({resultCode: 400})
              }),
            {pending: '다운로드 중입니다.'},
            {position: 'top-center', autoClose: 1000, className: 'fs-3 fw-bold'}
          )
          .catch(async () => {
            await resultAlert({resultCode: 400})
          })

      default:
        return await toast
          .promise(
            axiosWithAuth()
              .get(
                `${envBackHost}/${officeInfo?.value}/${cooperInfo?.value}${window.location.pathname}/excel?date=${filter.date}&userId=${userInfo?.userId}`,
                {
                  params: search,
                  responseType: 'blob',
                }
              )
              .then(async (res) => {
                await resultAlert({resultCode: 0})
                fileDownload(res.data, `${officeInfo?.label}_${filter.date}_${type}.xlsx`)
                onClose()
              })
              .catch(async () => {
                await resultAlert({resultCode: 400})
              }),
            {pending: '다운로드 중입니다.'},
            {position: 'top-center', autoClose: 1000, className: 'fs-3 fw-bold'}
          )
          .catch(async () => {
            await resultAlert({resultCode: 400})
          })
    }
  }

  const excelFilterDateHandler = (path: any) => {
    switch (path) {
      case '/task/as':
      case '/customer/minimum-flow':
      case '/customer/allocation':
      case '/customer/binary-check':
        return false
      default:
        return true
    }
  }

  const excelImageModeHandler = (path: any) => {
    switch (path) {
      case '/customer/info':
        return true
      default:
        return false
    }
  }

  const excelFormEditHandler = (path: any) => {
    switch (path) {
      case '/task/as':
        return (
          <span className='text-sm text-red-600 font-bold'>
            A/S 관리에서는 검색필터에 따라 데이터가 다운로드 됩니다.
          </span>
        )
      case '/customer/minimum-flow':
        return (
          <span className='text-sm text-red-600 font-bold'>
            최소 유량에서는 검색필터에 따라 데이터가 다운로드 됩니다.
          </span>
        )
      case '/customer/binary-check':
        return (
          <span className='text-sm text-red-600 font-bold'>
            {type}에서는 검색필터에 따라 데이터가 다운로드 됩니다.
          </span>
        )
      default:
        return (
          <Button
            variant={'contained'}
            size={'large'}
            color={'secondary'}
            className={`whitespace-nowrap ${isMobile ? 'w-full' : 'mx-2 col-3'}`}
            disabled={fixedExcelForm === FIELD_COMMUNICATION_QUALITY_REQUEST}
            onClick={() => setExcelFormEditOpen(true)}
          >
            엑셀 양식지정
          </Button>
        )
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        slots={{backdrop: Backdrop}}
        slotProps={{backdrop: {timeout: 300}}}
      >
        <div
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-6 w-full ${
            excelFilterDateHandler(path) ? 'max-w-5xl' : 'max-w-2xl'
          }`}
        >
          <div className='modal-content rounded-2'>
            <div className='modal-header'>
              <span
                className='modal-title text-[1.25rem] font-semibold p-4'
                id='downloadModalLabel'
              >
                {type} 다운로드
              </span>
              <button
                type='button'
                className='btn-close'
                aria-label='Close'
                onClick={onClose}
              ></button>
            </div>

            <div style={{padding: '24px 32px'}}>
              <div
                className={`flex ${
                  isMobile
                    ? 'flex-col'
                    : excelFilterDateHandler(path) || path === '/customer/check-report'
                    ? 'flex-row items-center'
                    : 'flex-col'
                } gap-4`}
              >
                {excelFilterDateHandler(path) && (
                  <div id={'date-range'} className={`text-center ${isMobile ? 'w-full' : 'col-5'}`}>
                    <div className={'d-flex gap-6 text-center w-100 justify-content-center'}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label='날짜 선택'
                          value={filter.date}
                          disabled={fixedExcelForm === FIELD_COMMUNICATION_QUALITY_REQUEST}
                          mask='____/__/__'
                          inputFormat={'YYYY/MM/DD'}
                          onChange={(newValue: any) => {
                            setFilter({
                              ...filter,
                              date: dayjs(newValue).format('YYYYMMDD'),
                            })
                          }}
                          className={'w-100'}
                          renderInput={(params) => <TextField fullWidth {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                )}
                <>
                  {excelFormEditHandler(path)}

                  <Button
                    variant={'contained'}
                    size={'large'}
                    className={`whitespace-nowrap ${isMobile ? 'w-full' : 'mx-2 col'}`}
                    onClick={() => {
                      getDownloadData(path)
                    }}
                  >
                    <DownloadIcon />
                    <span>데이터 다운로드</span>
                  </Button>
                </>
              </div>

              {excelImageModeHandler(path) && (
                <>
                  <Divider className='my-4 font-semibold text-[1.25rem] px-10'>
                    엑셀 다운로드 설정
                  </Divider>
                  <div className='px-10 text-[1rem]'>
                    <FormControl>
                      <FormLabel
                        sx={{
                          fontSize: 14,
                          color: 'text.primary',
                          '&.Mui-focused': {color: 'text.primary'},
                        }}
                      >
                        이미지 표현 방식
                      </FormLabel>
                      <RadioGroup value={imageMode} onChange={(e) => setImageMode(e.target.value)}>
                        <FormControlLabel
                          value={imageModeConst.recentImage}
                          disabled={fixedExcelForm === FIELD_COMMUNICATION_QUALITY_REQUEST}
                          control={<Radio />}
                          label={
                            <div>
                              <div>최근 이미지 사용</div>
                              <div className='text-base text-gray-500'>
                                등록된 가장 최근 이미지를 다운로드합니다.
                              </div>
                            </div>
                          }
                          sx={{'& .MuiFormControlLabel-label': {fontSize: 14}}}
                        />
                        <FormControlLabel
                          value={imageModeConst.todayFirstImageIfNull}
                          disabled={fixedExcelForm === FIELD_COMMUNICATION_QUALITY_REQUEST}
                          control={<Radio />}
                          label={
                            <div>
                              <div>
                                선택 날짜 이미지 우선 (없으면 선택 날짜 기준 최근 이전 이미지)
                              </div>
                              <div className='text-base text-gray-500'>
                                선택 날짜의 이미지가 있으면 해당 이미지, 없으면 최근 이미지를
                                다운로드합니다.
                              </div>
                            </div>
                          }
                          sx={{'& .MuiFormControlLabel-label': {fontSize: 14}}}
                        />
                      </RadioGroup>
                      <FormLabel
                        sx={{
                          fontSize: 14,
                          marginTop: 2,
                          color: 'text.primary',
                          '&.Mui-focused': {color: 'text.primary'},
                        }}
                      >
                        고정 엑셀 양식
                      </FormLabel>
                      <RadioGroup value={fixedExcelForm}>
                        <FormControlLabel
                          value={FIELD_COMMUNICATION_QUALITY_REQUEST}
                          control={
                            <Radio
                              onClick={() =>
                                setFixedExcelForm((prev) =>
                                  prev === FIELD_COMMUNICATION_QUALITY_REQUEST
                                    ? ''
                                    : FIELD_COMMUNICATION_QUALITY_REQUEST
                                )
                              }
                            />
                          }
                          label={
                            <div>
                              <div>현장통품점검 요청</div>
                              <div className='text-base text-gray-500'>
                                LG유플러스 현장 통품 점검 요청서 양식에 맞게 다운로드합니다.
                              </div>
                            </div>
                          }
                          sx={{'& .MuiFormControlLabel-label': {fontSize: 14}}}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </>
              )}
            </div>

            <div className='flex justify-end px-6 py-4 border-t border-gray-200'>
              <Button variant={'contained'} size={'large'} color={'error'} onClick={onClose}>
                나가기
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      <ExcelFormEditModal open={excelFormEditOpen} onClose={() => setExcelFormEditOpen(false)} />
      <ToastContainer />
    </>
  )
}
export default ExcelDownLoadModal
